







































































import {Component, Vue, Mixins, Prop, Watch} from "vue-property-decorator";
import { ClientProject, ClientProjectService, ClientProjectTask, ClientProjectTaskService } from "../../../../services/accounting.service";
import ClientProjectTaskList from "./List.vue"
import ClientProjectTaskForm from "./Form.vue"
import LogHoursForm from './LogHoursForm.vue'

@Component({
    components: {
        ClientProjectTaskList,
        ClientProjectTaskForm,
        LogHoursForm,
    }
})
export default class ClientProjectsIndex extends Vue {

    @Prop()
    public project!: ClientProject;

    initialized: boolean = false;
    
    formOpen: boolean = false;
    addressFormOpen: boolean = false;
    editing: {[key: string]: ClientProjectTask} = {};
    logging: {[key: string]: ClientProjectTask} = {};
    tasks: ClientProjectTask[] = [];

    api!: ClientProjectTaskService;

    loading = false;

    async created() {
        this.api = new ClientProjectTaskService('');
        this.initialized = true;
        await this.refresh();
    }

    @Watch('project', {deep: true})
    public async projectChange() {
        if (this.project) this.api = new ClientProjectTaskService(this.project.id);
        await this.refresh();
    }

    async refresh() {
        this.loading = true;
        const res = await this.api.get();
        if (res.success) {
            this.tasks= res.result;
            for (const task of this.tasks) {
                if (task.id in this.editing) {
                    this.editing[task.id] = task;
                }
            }
        }
        this.loading = false;
    }

    isEditing(task: ClientProjectTask) {
        return task.id in this.editing;
    }

    isLogging(task: ClientProjectTask) {
        return task.id in this.logging;
    }

    log(task: ClientProjectTask) {
        this.logging[task.id] = task;
        this.$forceUpdate();
    }

    cancelLog(task: ClientProjectTask) {
        delete this.logging[task.id];
        this.$forceUpdate();
    }

    async logSuccess(task: ClientProjectTask) {
        delete this.logging[task.id];
        await this.refresh();
        this.$emit('update');
        this.$forceUpdate();
    }

    cancelEdit() {
        this.formOpen = false;
    }

    cancelEditTask(task: ClientProjectTask) {
        delete this.editing[task.id];
        this.$forceUpdate();
    }

    async create() {
        this.formOpen = true;
    }

    async edit(project: ClientProjectTask) {
        this.editing[project.id] = project;
        this.$forceUpdate();
    }

    async remove(project: ClientProjectTask) {
        await this.api.delete(project.id);
        await this.refresh();
    }

    async saveSuccess(task: ClientProjectTask) {
        delete this.editing[task.id];
        await this.refresh();
        this.$emit('update');
    }

    async success() {
        this.formOpen = false;
        await this.refresh();
    }
}
